import 'react';
import 'reakit-system/useToken';
import 'color';
import './isLight.js';
import './contrast.js';
import '../palette.js';
import { getPalette } from './palette.js';

function ref(name, fallback) {
  return function (palette) {
    return getPalette(palette, name) || fallback;
  };
}

export { ref };